const messages = {
    fields: {
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        address: 'Straat',
        postcode: 'Postcode',
        city: 'Plaats',
        phone: 'Telefoonnummer',
        house_number: 'Huisnummer',
        password: 'Wachtwoord',
    },
    customPages: {
        mainCategory: 'Hoofdcategoriën',
    },
    validations: {
        required: '{field} is verplicht',
        invalid: '{field} is onjuist',
    },
    blockCart: {
        addToCart: "Toevoegen aan winkelwagen",
        addedToCartTitle: "Toegevoegd aan uw winkelwagen",
        proceedToCheckout: "Winkelwagen",
        productTotal: "Totaal",
        showAllProducts: "Bekijk alle producten",
        cartShipping: "Verzendkosten",
        cartTotal: "Totaal",
        close: "Sluiten",
        addedToCartChoiceTitle: "Uw keuze:",
        noItemSelected: "Geen variant geselecteerd!",
    },
    myAccount: {
        titlePersonalInformation: 'Mijn gegevens',
        adjustData: 'Gegevens wijzigen',
        setNewPassword: 'Nieuw wachtwoord instellen?',
        phoneNumberMessage: 'De bezorger kan contact met u opnemen',
        houseNumber: 'Nr',
        optional: 'Optioneel',
        currentPassword: 'Huidig wachtwoord',
        newPassword: 'Nieuw wachtwoord',
        email: 'E-mailadres',
        titleOrderHistory: 'Bestellingen',
        logout: 'Uitloggen',
        loading: 'Laden...',
        yourCart: 'Uw winkelwagen',
        address2: 'Aanvullende adresinformatie',
        addAddress: 'Adres toevoegen',
        defaultAddress: 'Standaard adres',
        setAsDefaultAddress: 'Standaard adres',
        adjust: 'Aanpassen',
        name: 'Naam',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        address: 'Straat',
        zipcode: 'Postcode',
        residence: 'Woonplaats',
        country: 'Land',
        phone: 'Telefoon',
        phoneNumber: 'Telefoonnummer',
        copyAddress: 'Adres kopiëren',
        delete: 'Verwijderen',
        errorMessage: 'Oeps! Foutje gevonden',
        cancel: 'Annuleren',
        save: 'Opslaan',
        packaging: 'Verpakking',
        unitPrice: 'Stukprijs',
        price: 'Prijs',
        totalPriceProducts: 'Totaalprijs bestelde product(en)',
        total: 'Totaal',
        freeOfCharge: 'Gratis',
        taxIncl: 'incl. btw',
        continueToOrder: 'Naar de kassa',
        easyReorder: 'Eenvoudig herbestellen!',
        easyReorderMessage: 'Voeg uit vorige bestellingen producten toe en reken af.',
        emtpyOrderMessage:
            'Wanneer u een bestelling heeft geplaatst komt die hier te staan met informatie over levertijd, uw factuur, etc. U kunt eerdere bestellingen ook eenvoudig herbestellen vanaf deze pagina.',
        emtpyOrderMessage2: 'Klik',
        emtpyOrderMessage3: 'hier',
        emtpyOrderMessage4: ' om naar de home page te gaan.',
        reorder: 'Herbestellen',
        products: 'Product(en)',
        totalShipmentCost: 'Totaal verzendkosten',
        shipmentCost: 'Verzendkosten',
        status: 'Status',
        detailsInvoice: 'Details & Factuur',
        downloadInvoice: 'Download factuur ',
        shippedBy: 'Verzonden door',
        paymentMethod: 'Betaalmethode',
        deleteAddressModalText: 'Weet u zeker dat u dit adres wilt verwijderen?',
        deleteAddressModalLoaderText: 'Bezig met verwijderen?',
        errorModalText: 'Sorry, er is iets foutgegaan',
        errorModalText2: 'Probeer het later opnieuw',
        appModalTitle: 'Brekz - Online Dierenwinkel - App',
        appModalText:
            'Op elk moment alles voor uw huisdier kunnen bestellen? Vanaf nu kunt u dit gemakkelijk doen via de Brekz App.\n' +
            'Duizenden producten zoals voer, lekkere snacks en leuke speeltjes op één plek gemakkelijk bestellen.',
        appModalText2: 'U vindt de app in de Play Store en App Store',
        appModalListTitle: 'Voordelen',
        appModalListItem: '- Altijd uw dierenwinkel bij de hand',
        appModalListItem1: ' - Gemakkelijk en snel herbestellen',
        appModalListItem2: '- Handige notificaties over bestellingen en',
        appModalListItem3: '- Instellen welke / hoeveel meldingen u wilt ontvangen',
        appModalListItemLink: 'Aanbiedingen',
        reorderModalSorry: 'Helaas niet op voorraad',
        reorderModalOutOfStock: 'niet leverbaar',
        reorderModalPackaging: 'De volgende verpakking is ',
        reorderModalSkip: 'Dit product overslaan',
        reorderModalAlternativesInStock: 'Alternatieven die op voorraad zijn',
        reorderModalQuantity: 'Hoeveelheid',
        pricePerUnit: 'Prijs per stuk',
        addProduct: 'toevoegen',
        bundleDiscount: 'Bundelvoordeel',
        discount: 'Bespaar',
        reorderModalOrderAlternative: 'alternatief bestellen',
        saveConfirmationModalTitle: 'Uw gegevens zijn opgeslagen',
        minimumPurchaseMessage:
            'De minimum bestelwaarde bedraagt {amount} (exclusief verzendkosten) Voeg 1 of meer producten toe aan uw winkelwagen om verder te gaan.',
        trackAndTraceText: 'Volg uw bestelling (beschikbaar nadat uw pakket is verzonden)',
        noAlternativeProducts: 'Er zijn helaas geen alternatieve verpakkingen voor uw eerdere bestelling',
        addressDescription: 'Hier vindt u een overzicht van uw adresgegevens. U kunt ze hier ook wijzigen.\n',
        titleMyOrders: 'Mijn Bestellingen',
        orderDescription: 'Bekijk de status van uw bestelling, uw factuur of bestel eenvoudig opnieuw\n',
        orderDescriptionShort: 'Bekijk de status van uw bestelling\n',
        addresses: 'Mijn adressen',
        okay: 'Oke',
        errorFirstName: 'Vul de voornaam goed in',
        errorLastName: 'Vul de achternaam goed in',
        errorEmail: 'Controleer uw e-mailadres',
        errorPhone: 'Controleer uw telefoonnummer',
        errorAddress: 'Controleer de straatnaam en huisnummer',
        errorAddress2: 'Controleer de straatnaam en huisnummer',
        errorZipcode: 'Postcode onjuist',
        errorCity: 'Controleer uw woonplaats',
        errorPassword: 'Wachtwoord ontbreekt of is te kort',
        eraseWarning: 'U staat op het punt om alle ingevulde gegevens te wissen!',
        eraseConfirmation: 'Weet u zeker het zeker?',
        amount: 'Aantal',
        orderDate: 'Orderdatum',
        trackAndTrace: 'Track & Trace',
        close: 'Sluiten',
        toCart: 'Naar winkelwagen',
        productsInCart: 'Producten zijn toegevoegd aan uw winkelwagentje',
        orderInCart: 'Uw bestelling is toegevoegd aan uw winkelwagentje',
        productsInColumn:
            'U vindt ze in de rechterkolom op deze pagina, of klik op het winkelwagen icoontje rechts bovenaan de pagina',
        orderStatus: 'Status van uw bestelling',
        orderProcess: 'Uw bestelling doorloopt in de meeste gevallen de volgende stappen:',
        paymentWaiting: 'Wachten op betaling',
        paymentReceived: 'Betaling ontvangen',
        orderCollected: 'Bestelling wordt verzameld',
        orderSent: 'Uw bestelling is verzonden',
        followOrder: 'U kunt uw pakket nu volgen via ',
        followOrderEnd: '.',
        multiplePackages: 'NB: Bestelling bevat meerdere pakketten',
        trackAndTraceActiveTime: 'NB: het kan even duren voordat de link actief wordt',
        delivered: 'Bezorgd',
        password: 'Wachtwoord',
        didYouMean: 'Bedoel je misschien',
        apply: 'Toepassen',
        bundle: 'Bundel',
        bundlePriceWas: 'Was',
        saving: 'Bespaar',
    },
    checkout: {
        between: 'Tussen',
        and: 'en',
        delivery: 'Bezorging',
        countdownMessage1: 'Bestel binnen',
        countdownMessage2: 'voor de snelste bezorging',
        newCard: 'Nieuwe creditcard gebruiken',
        creditCard: 'Creditcard',
        addNewCard: 'Nieuwe {card} toevoegen',
        passwordMessage: 'Minimaal 5 karakters',
        loading: 'Laden...',
        lastStep: 'Laatste stap',
        savedCard: 'Opgeslagen {card} gebruiken',
        cardNumber: 'Kaartnummer',
        otherCard: 'Andere {card} gebruiken',
        expireDate: 'Vervaldatum',
        errorCard: 'Deze kaart is niet geldig of is niet ondersteund',
        errorName: 'Huidige naam is niet geldig',
        errorDate: 'Huidige vervaldatum is niet geldig of is verlopen',
        errorCVV: 'Huidige CVV is niet geldig',
        cardExpired: 'Deze kaart is verlopen in ons systeem. Vul a.u.b. de kaart opnieuw in.',
        saveCard: '{card} opslaan',
        nextTime: 'voor de volgende keer',
        order: 'Bestellen',
        back: 'Terug naar betaalopties',
        addressEdit: 'Adres bewerken',
        paymentSucces: 'Uw betaling is succesvol ontvangen',
        backToOrderhistory: 'U wordt binnen enkele seconden doorgestuurd naar uw besteloverzicht.',
        bancontactNotAvailable: 'Bancontact is niet beschiktbaar op ',
        allData: 'Al uw gegevens zijn ',
        secured: 'beveiligd',
        almostDone: 'Bijna klaar',
        banContactNotAvailable: 'Bancontact is niet beschiktbaar op',
        payWith: 'Reken af met uw',
        bancontactApp: 'Bancontact app',
        useOtherBancontact: 'Andere Bancontact gebruiken',
        useNewBancontact: 'Nieuwe Bancontact gebruiken',
        addNewBancontact: 'Nieuwe Bancontact toevoegen',
        payWithBancontactApp: 'Betaal met de bancontact App',
        openBancontactApp: 'Open de bancontact app en scan de code om de betaling met de app af te ronden',
        noBancontactApp: 'Heeft u de app niet? Gebruik dan de methode hiernaast.',
        mistercacheSave: 'Bancontact opslaan',
        cardHolderNamePlaceholder: 'J. JANSSEN',
        newAccount: 'Waar mag het pakket naartoe?',
        cancel: 'Annuleren',
        taxIncl: 'incl. btw',
        total: 'Totaal',
        name: 'Naam',
        close: 'Sluiten',
        errorText: 'Sorry, er is iets foutgegaan',
        errorModalText: 'Sorry, er is iets foutgegaan tijdens de betaling',
        errorModalText2: 'Probeer het later opnieuw',
        rememberAddressHeaderTitle: 'Bespaar tijd bij uw volgende aankoop',
        rememberAddressSwitchLabel: 'Gebruik dit adres en deze betaaloptie bij volgende bestellingen',
        paymentSecurityText: 'Al uw gegevens zijn',
        paymentSecurityTextBold: 'beveiligd',
        paymentCardHeaderTitle: 'Betaalopties',
        addressCardHeaderTitle: 'Bezorgadres',
        invoiceAddress: 'Factuuradres',
        editAddress: 'Aanpassen',
        addNewAddress: 'Nieuw adres toevoegen',
        addNewInvoiceAddress: 'Nieuw factuuradres toevoegen',
        addressMatchesInvoiceAddress: 'Factuuradres is gelijk aan bezorgadres',
        addressMatchesNotInvoiceAddress: 'Factuuradres is niet gelijk aan bezorgadres',
        // checkout progressbar
        progressbarLogIn: 'Inloggen',
        progressbarPaymentOption: 'Betaaloptie',
        progressbarPayment: 'Betaling',
        progressbarDone: 'Klaar!',
        klarnaPhoneNumberRequiredModal: {
            modalMessage:
                'U heeft gekozen voor achteraf betalen met <strong>Klarna</strong>. Hiervoor is uw telefoonnummer nodig.',
            phoneNumberInputField: 'Voer hier uw telefoonnummer in',
            otherPaymentMethod: 'Andere betaalmethode kiezen',
        },
        validationErrors: {
            noPaymentMethodSelected: 'U heeft nog geen betaalmethode gekozen',
            noAddressSelected: 'U heeft nog geen bezorg- en/of factuuradres gekozen',
            paymentMethodRequiresPhoneNumber:
                'Uw telefoonnummer ontbreekt in uw adresgegevens. Voeg dit toe om met Klarna te kunnen betalen',
            termsOfServices: 'U heeft de Algemene voorwaarden niet geaccepteerd',
            noDeliveryOnThisAddress:
                'Helaas leveren we niet op de postcode die je hebt opgegeven. Tijdens het bestellen kun je ervoor kiezen om het pakket op een andere postcode te laten bezorgen.',
        },
        processWaiting: {
            title: 'Betaling wordt verwerkt',
            description: 'Een ogenblik geduld a.u.b.',
        },
    },
    address: {
        placeholderFirstname: 'Jan',
        placeholderLastname: 'Janssen',
        placeholderAddress: 'Stationsweg',
        placeholderAddress2: 'Bus nr, etage, bedrijfsnaam etc.',
        placeholderZipcode: '1234',
        placeholderCity: 'Antwerpen',
        placeholderPhone: '0412345678',
        noShipping:
            'Op de door u gekozen postcode gelden helaas extra verzendkosten. Om deze kosten te voorkomen kunt u het pakket laten leveren op andere postcode.',
    },
    outOfStockNotificationOptin: {
        modalTitle: 'Houd me op de hoogte',
        modalMessage: 'Je ontvangt eenmalig een e-mail zodra dit product weer op voorraad is.',
        modalSubmitButton: 'Houd me op de hoogte',
        email: 'E-mailadres',
        placeholderEmail: 'voorbeeld@email.com',
        noAbuse: 'Je e-mailadres wordt niet gebruikt voor andere doeleinden.',
        alreadySignedUp: 'Je bent al aangemeld voor dit product.',
        invalidEmail: 'Ongeldig e-mailadres',
        genericError: 'Er is iets misgegaan',
    },
    orderConfirmation: {
        modalTitle: 'Wilt u uw bestelling kunnen volgen?',
        modalMessage:
            'U heeft als <b>gast</b> besteld. Voeg een <b>wachtwoord</b> toe en volg <b>uw bestelling</b> in het besteloverzicht van uw persoonlijke account.',
        enterPassword: 'Wachtwoord toevoegen',
        minimumWarning: 'Minimaal 5 karakters',
        passwordTooShort: 'Het ingevoerde wachtwoord is te kort',
        somethingWentWrong: 'Er is een algemene fout opgetreden',
    },
    unsubPage: {
        emailQuestion: 'Voor welk email adres?',
        emailKnown: 'Email adres vanuit uw account: ',
        emailadres: 'E-mailadres:',
        changeEmailSettings: 'E-mail instellingen aanpassen',
        iWant: 'Ik wil',
        iWant2: 'Ik wil',
        keepProfiting: 'blijven profiteren ',
        ofTheBenefitMail: 'van de voordeelmail',
        sendMe: 'Stuur mij',
        onesEvery2Weeks: 'één keer in de twee weken',
        exclusiveOffersAndTheBestDiscounts: 'exclusieve aanbiedingen en de beste kortingen',
        onetimeAMonth: '1x per maand',
        wellEnoughButDontMiss: 'is wel genoeg, maar ik wil geen voordeel missen',
        noBenefit: 'Voor mij geen voordeel meer,',
        writeMeOut: 'ik schrijf me uit',
        benefitMail: 'voordeelmail',
        birthdayMail: 'Verjaardagsmail',
        tipsAndAdvice: 'Tips & Advies',
        personalDiscount: 'Persoonlijke kortingen',
        productReviewAndReviews: 'Productbeoordeling en reviews',
        stillReceiveUpdatesAboutDelivery: 'U ontvangt uiteraard nog wel updates over uw bestelling en levering',
        feedBackAndTips: 'Heeft u nog tips of feedback voor ons?',
        cancel: 'Annuleren',
        benefitDogCat: 'Voordeel voor hond of kat toevoegen?',
        iWantBenefitFor: 'Ik wil graag voordeel voor',
        dogs: 'Honden',
        cats: 'Katten',
        dogsAncCats: 'Honden en Katten',
        no: 'geen',
        receiveMoreBenefitFor: 'voordeel meer ontvangen voor',
        giveMe: 'Geef mij',
        allBenefit: 'al het voordeel',
        average2MailsAWeek: '(gemiddel 2 voordeelmails per week)',
        oneTime2Weeks: '1x per twee weken',
        save: 'Opslaan',
        received: '',
        selectVariant: 'Kies variant',
        YouAreSuccessfullyUnsubscribedFor: 'U bent succesvol uitgeschreven voor:',
        checkYourEmail: 'Controleer uw e-mailadres',
        noOptionSelected: 'Er is geen optie geselecteerd',
    },
    algoliaSearch: {
        mqc: {
            max: 'Max',
            perCustomer: 'Per Klant',
        },
        searchButton: 'Zoeken',
        searchPlaceholder: 'Typ hier je zoekopdracht',
        searchBarInputPlaceholder: 'Zoek over meer dan 6000 producten',
        searchBarInputPlaceholderApp: '6000+ producten',
        noResultsContentTitleCategory: 'Helaas zijn er geen producten gevonden met de geselecteerde filters.',
        noResultsContentTitle:
            'We konden <b>geen resultaten</b> vinden voor <span class="algolia-listing-no-results__content-title--brand">“{query}“</span>',
        noResultsContentListTitle: 'Wat kunt u doen:',
        noResultsContentListItemOne: 'Controleer de spelling van uw zoekopdracht',
        noResultsContentListItemOneCategory: 'verwijder een of meerdere filters',
        noResultsContentListItemTwo:
            'Zocht u op een merknaam? Dan kan het zijn dat we dit merk helaas (nog) niet in ons assortiment hebben',
        noResultsContentListItemTwoCategory: 'Klik op wis alles om een nieuwe selectie te starten',
        noResultsContentListItemThree: 'Probeer een andere zoekopdracht',
        noResultsWithQuery: 'Geen suggesties gevonden voor <b>"{query}"</b>',
        searchHistoryTitle: 'Eerder door u gezocht',
        searchResultsHeader: '<b>{resultCount}</b> resultaten voor <b>"{query}"</b> in alle artikelen.',
        searchResultsHeaderSubtitle: 'Verfijn uw resultaten met onderstaande filters.',
        searchResultsTitle: 'Zoeksuggesties',
        popularProductsTitle: 'Favorieten',
        popularCategoriesTitle: 'Populaire categorieën',
        queryMirrorTitle: 'Uw zoekopdracht',
        resultsHitsProducts: 'Producten',
        resultsHitsDelete: 'Wis alles',
        resultsHitsFilter: 'Filteren',
        resultsHitsFilterNote: 'Gebruik de filters om sneller te vinden wat u zoekt',
        fiterPanelMobileHeaderTitle: 'Filteren',
        fiterPanelMobileHeaderSubtext: 'Gebruik filters om sneller te vinden wat u zoekt',
        fiterPanelMobileDeleteFilters: 'Wis alles',
        fiterPanelMobileFilteredProductAmount: 'producten',
        fiterPanelMobileSaveSelection: 'Selectie opslaan',
        fiterPanelMobileFooterTextPartOne: 'Filter',
        fiterPanelMobileFooterTextPartTwo: 'resultaten',
        hitItemFromLabel: 'vanaf:',
        hitItemViewProduct: 'Bekijk product',
        refinementListViewMore: 'Meer...',
        refinementListViewLess: 'Minder...',
        refinementListRangeBoxInbetween: 'tot',
        unAvailableNotePartOne: 'op',
        unAvailableNotePartTwo: 'weer verkrijgbaar',
        filters: {
            priceReduction: {
                on: 'Ja',
                off: 'Nee',
            },
        },
    },
    algoliaRecommend: {
        recommendedProducts: 'Vergelijkbare producten',
        recommendedProductsSubtitle: 'Anders, maar óók top!',
        boughtTogether: 'Vaak samen gekocht',
        boughtTogetherSubtitle: 'in één keer klaar!',
    },
    mobileMenu: {
        makeYourChoice: 'Maak uw keuze',
    },
    combinationPromotion: {
        op: 'OP = OP',
        bonus: 'Bonusbag',
        twoPlusOneFree: '2 + 1 Gratis',
        minusTenPercent: '-10%',
        minusTwentyPercent: '-20%',
        minusTwentyFivePercent: '-25%',
        minusThirtyPercent: '-30%',
        minusFortyPercent: '-40%',
        minusFiftyPercent: '-50%',
        minusSixtyPercent: '-60%',
        minusSeventyPercent: '-70%',
    },
    resetPassword: {
        passwordError: 'Wachtwoorden komen niet overeen',
        passwordForgot: 'Wachtwoord vergeten?',
        createNewPassword: 'Nieuw wachtwoord aanmaken',
        description:
            'Vul het E-mailadres van uw account in. We sturen een link naar dit e-mailadres waarmee u een nieuw wachtwoord kunt instellen.',
        email: 'E-mailadres',
        note: 'Het kan even duren voordat u de link ontvangt. Gelieve minimaal 4 minuten te wachten met opnieuw aanvragen van een link. Dit voorkomt dat u een niet-werkende link ontvangt. ',
        setNewPassword: 'Nieuw wachtwoord instellen',
        chooseNewPassword: 'Kies uw nieuwe wachtwoord',
        newPassword: 'Nieuw wachtwoord',
        reenterPassword: 'Voer nogmaals uw nieuwe wachtwoord in',
        passwordsDontMatch: 'Wachtwoord in veld 2 is niet gelijk aan veld 1',
        passwordsDontMatchError: 'Wachtwoorden komen niet overeen',
        submit: 'Versturen',
    },
};
export default messages;
